webpackJsonp([12],{

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(226)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(253),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video',
  metaInfo: {
    title: 'Video recordings from events in Progressbar'
  }
});

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, ".button.is-black.is-block.is-large.meeting{background-image:-webkit-gradient(linear,left bottom,right top,from(#b60cf6),color-stop(#9316e5),color-stop(#711ad4),color-stop(#4c1ac1),to(#1e19ae));background-image:-webkit-linear-gradient(left bottom,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae);background-image:-o-linear-gradient(left bottom,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae);background-image:linear-gradient(to right top,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae)}.notification{padding:0}@media only screen and (max-width:768px){iframe{width:85vw;height:15em}}h1 a{color:hotpink}iframe{width:100%}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/Video.vue"],"names":[],"mappings":"AACA,2CACE,sJAA8J,AAC9J,8FAAoG,AACpG,yFAA+F,AAC/F,sFAA6F,CAC9F,AACD,cACA,SAAW,CACV,AACD,yCACA,OACI,WAAY,AACZ,WAAa,CAChB,CACA,AACD,KACE,aAAc,CACf,AACD,OACE,UAAY,CACb","file":"Video.vue","sourcesContent":["\n.button.is-black.is-block.is-large.meeting {\n  background-image: -webkit-gradient(linear, left bottom, right top, from(#b60cf6), color-stop(#9316e5), color-stop(#711ad4), color-stop(#4c1ac1), to(#1e19ae));\n  background-image: -webkit-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: -o-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: linear-gradient(to right top, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n}\n.notification {\npadding: 0;\n}\n@media only screen and (max-width: 768px) {\niframe {\n    width: 85vw;\n    height: 15em;\n}\n}\nh1 a {\n  color:hotpink;\n}\niframe {\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(202);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("7ff63c48", content, true, {});

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black is-size-4"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Want better quality? Same here.")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('router-link', {
    staticClass: "button is-black is-block is-large meeting",
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("\n              Support US!\n            ")])], 1)])])]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('p'), _c('h1', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/playlist?list=PLfCtn83lMV3BqBe45jgaNw4LqPNnhq6IG"
    }
  }, [_vm._v("Playlist of Archived Streams\n      ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCpun3Ro3aUJPoFVZwgqd98A"
    }
  }, [_vm._v("📥 Subscribe to Progressbar Channel\n      ")])]), _vm._v(" "), _c('iframe', {
    staticClass: "mainiframe",
    attrs: {
      "height": "800",
      "src": "https://www.youtube-nocookie.com/embed/videoseries?list=PLfCtn83lMV3BqBe45jgaNw4LqPNnhq6IG",
      "loading": "lazy",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("👼 Digital slides (200€+)")]), _vm._v(" "), _c('p', [_vm._v("🧠 Better audio quality (300€+)")]), _vm._v(" "), _c('p', [_vm._v("👩‍🎨 Better camera (600€+)")]), _vm._v(" "), _c('p', [_vm._v("📚 More camera angles (600€+/ks)")]), _vm._v(" "), _c('p', [_vm._v("🎧 General improvements (100€/)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-8"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('h1', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Also recorded in Progressbar:")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('iframe', {
    attrs: {
      "height": "360",
      "src": "https://www.youtube-nocookie.com/embed/videoseries?list=PLfCtn83lMV3CzkXkGdkdUnNZvD5c4hBbC",
      "loading": "lazy",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('iframe', {
    attrs: {
      "height": "360",
      "src": "https://www.youtube.com/embed/videoseries?list=PL7Q4UCybIXBG5SkXQX0CqLBQbaCVWYjvF",
      "loading": "lazy",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.7bf5d9a8d7e2632344c8.js